import { Button } from '@library/components/buttons';
import { cn } from '@library/component-utils/cn';

export interface ActionButtonProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  handleOnClick: React.MouseEventHandler<HTMLButtonElement>;
  dataTestId?: string;
  title: string;
  variant?: 'primary' | 'secondary';
}

export const ActionButton = ({
  children,
  className = '',
  disabled = false,
  handleOnClick,
  dataTestId = 'action-button',
  title,
  variant = 'primary'
}: ActionButtonProps) => {
  const variantStylesMap = {
    primary:
      'bg-stankonia-100 text-soClean-100 disabled:bg-stankonia-300 disabled:text-soClean-180',
    secondary:
      'bg-soFresh-120 text-soClean-100 disabled:bg-soFresh-150 disabled:text-soClean-180'
  };
  const variantStyles = variantStylesMap[variant];

  return (
    <Button
      className={cn(
        'text-soClean-100 disabled:text-soClean-180 flex h-10 max-h-10 cursor-pointer items-center rounded-md px-4 py-2 text-center text-[13px] font-medium disabled:cursor-not-allowed',
        variantStyles,
        className
      )}
      disabled={disabled}
      aria-disabled={disabled}
      onClick={handleOnClick}
      type="button"
      title={title}
      data-testid={dataTestId}
    >
      {children}
    </Button>
  );
};
